import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getApplications } from 'services/CustomerService'

export const useGetApplicationsQuery = (enabled = true) => {
  return useQuery({
    queryKey: reactQueryKeys.applications(),
    queryFn: () => getApplications(),
    enabled,
  })
}
